import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";

const VendorModalPolicy = () => {
    return (
        <div className="vendor-modal-policy-wrapper">
            <div className="modal-box" id="modal-policy-box">
                <IconName name="expand_close" className="icon position-absolute close-icon close-policy-modal"/>
                <h3 className="title-modal">فروشنده عزیز</h3>
                <p className="text-modal">
                    سایمان دیجیتال، یکی از بهترین فروشگاه های آنلاین با تخصص ویژه در زمینه گوشی و تبلت در کشور بوده و
                    همواره به عنوان مرجع خرید اینترنتی گوشی، تبلت، ساعت هوشمند ، لوازم جانبی و سایر کالاهای دیجیتال به
                    شمار می آید. ما در سایمان دیجیتال با هدف تسهیل روند خرید و ارائه پایین ترین قیمت در زمینه گوشی و
                    سایر کالاهای دیجیتال فعالیت خود را آغاز نمودیم و در تلاشیم تا محصولات بروز در این زمینه را به بهترین
                    شکل ممکن عرضه کنیم. به طوری که با گردآوری تمامی برند های معتبر (اپل، سامسونگ، هواوی، شیائومی، سونی،
                    نوکیا، گوگل، اچ تی سی، بلک بری، کاترپیلار، ایسوس، میزو، موتورولا، ال جی ، وان پلاس و …) در زمینه
                    گوشی، تبلت، ساعت هوشمند و متحد بودن به چهار اصل “مشتری مداری” “پایین ترین قیمت ممکن”، “ضمانت اصالت
                    کالا” ، “ارسال سریع” تجربه خرید مطمئن و راحت را برای مشتریان فراهم می نماییم. ما با ایجاد و تهیه
                    امکاناتی همچون ویدئو آنباکس(جعبه گشایی)، بررسی، مقایسه و نمودار قیمت در محصولات توانسته ایم روند
                    انتخاب و خرید گوشی و یا سایر کالاها را آسانتر کرده و طعمی لذت بخش از خرید اینترنتی را به مشتریان خود
                    منتقل کنیم.
                </p>
                <div className="text-big-modal">
                    <p className="text">
                        سایمان دیجیتال، یکی از بهترین فروشگاه های آنلاین با تخصص ویژه در زمینه گوشی و تبلت در کشور بوده
                        و همواره به عنوان مرجع خرید اینترنتی گوشی، تبلت، ساعت هوشمند ، لوازم جانبی و سایر کالاهای
                        دیجیتال به شمار می آید. ما در سایمان دیجیتال با هدف تسهیل روند خرید و ارائه پایین ترین قیمت در
                        زمینه گوشی و سایر کالاهای دیجیتال فعالیت خود را آغاز نمودیم و در تلاشیم تا محصولات بروز در این
                        زمینه را به بهترین شکل ممکن عرضه کنیم. به طوری که با گردآوری تمامی برند های معتبر (اپل، سامسونگ،
                        هواوی، شیائومی، سونی، نوکیا، گوگل، اچ تی سی، بلک بری، کاترپیلار، ایسوس، میزو، موتورولا، ال جی ،
                        وان پلاس و …) در زمینه گوشی، تبلت، ساعت هوشمند و متحد بودن به چهار اصل “مشتری مداری” “پایین ترین
                        قیمت ممکن”، “ضمانت اصالت کالا” ، “ارسال سریع” تجربه خرید مطمئن و راحت را برای مشتریان فراهم می
                        نماییم. ما با ایجاد و تهیه امکاناتی همچون ویدئو آنباکس(جعبه گشایی)، بررسی، مقایسه و نمودار قیمت
                        در محصولات توانسته ایم روند انتخاب و خرید گوشی و یا سایر کالاها را آسانتر کرده و طعمی لذت بخش از
                        خرید اینترنتی را به مشتریان خود منتقل کنیم.

                        ما، به منظور تسهیل در ارسال و تامین کالا، در شهرهای تهران، تبریز، شیراز و بوشهر مراکز انبارداری
                        کالا ایجاد کردیم تا بتوانیم محصولات موجود در هر انبار را در زمان مناسب تر و سریعتری به دست مصرف
                        کننده نهایی برسانیم و همیشه سعیمان بر آن است که بنا به طیف گسترده این محصولات، در حد امکان "بدون
                        تامین کننده" ارائه خدمت کنیم.

                        شایان ذکر است هم اکنون دفتر مرکزی ما در تبریز بوده و ارسال کالا برای خرید های بالای یکصد هزار
                        تومان در این شهر به صورت رایگان انجام می پذیرد.
                        سایمان دیجیتال، یکی از بهترین فروشگاه های آنلاین با تخصص ویژه در زمینه گوشی و تبلت در کشور بوده
                        و همواره به عنوان مرجع خرید اینترنتی گوشی، تبلت، ساعت هوشمند ، لوازم جانبی و سایر کالاهای
                        دیجیتال به شمار می آید. ما در سایمان دیجیتال با هدف تسهیل روند خرید و ارائه پایین ترین قیمت در
                        زمینه گوشی و سایر کالاهای دیجیتال فعالیت خود را آغاز نمودیم و در تلاشیم تا محصولات بروز در این
                        زمینه را به بهترین شکل ممکن عرضه کنیم. به طوری که با گردآوری تمامی برند های معتبر (اپل، سامسونگ،
                        هواوی، شیائومی، سونی، نوکیا، گوگل، اچ تی سی، بلک بری، کاترپیلار، ایسوس، میزو، موتورولا، ال جی ،
                        وان پلاس و …) در زمینه گوشی، تبلت، ساعت هوشمند و متحد بودن به چهار اصل “مشتری مداری” “پایین ترین
                        قیمت ممکن”، “ضمانت اصالت کالا” ، “ارسال سریع” تجربه خرید مطمئن و راحت را برای مشتریان فراهم می
                        نماییم. ما با ایجاد و تهیه امکاناتی همچون ویدئو آنباکس(جعبه گشایی)، بررسی، مقایسه و نمودار قیمت
                        در محصولات توانسته ایم روند انتخاب و خرید گوشی و یا سایر کالاها را آسانتر کرده و طعمی لذت بخش از
                        خرید اینترنتی را به مشتریان خود منتقل کنیم.

                        ما، به منظور تسهیل در ارسال و تامین کالا، در شهرهای تهران، تبریز، شیراز و بوشهر مراکز انبارداری
                        کالا ایجاد کردیم تا بتوانیم محصولات موجود در هر انبار را در زمان مناسب تر و سریعتری به دست مصرف
                        کننده نهایی برسانیم و همیشه سعیمان بر آن است که بنا به طیف گسترده این محصولات، در حد امکان "بدون
                        تامین کننده" ارائه خدمت کنیم.
                    </p>
                </div>
                <div className="check-policy d-block d-lg-flex justify-content-between align-items-center xmt-4">
                    <div className="check-boxes d-flex flex-column">
                        <label className="form-check-label" htmlFor="flex-radio-policy--1">
                            <input className="form-check-input" type="radio" name="flexRadioDefault"
                                   id="flex-radio-policy--1" value="valid"/>
                            قرار داد همکاری را مطالعه کردم و موافقم
                        </label>
                        <label className="form-check-label xmt-2" htmlFor="flex-radio-policy--2">
                            <input className="form-check-input" type="radio" name="flexRadioDefault"
                                   id="flex-radio-policy--2" value="not-valid"/>
                            با شرایط قرارداد موافق نیستم و مایل به خاتمه ثبت نام هستم
                        </label>
                    </div>
                    <div className="button-policy xmt-6 xmt-lg-0">
                        <Link to="/vendorUploadFile" id="vendor-policy-confirmation" className="button-check disabled-style">بله تایید میکنم</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorModalPolicy;
